export default "__VITE_ASSET__gzB1OaSm__"